import Axios from 'axios';
import { toast } from 'react-toastify';
import * as Redux from './redux-store';
import LogoKhc from 'assets/img/KH-logo.png';
import LogoCodeLotus from 'assets/img/code-lotus-logo.png';
import BadgeKhc from 'assets/img/badge-khc.svg';
import BadgeCodeLotus from 'assets/img/badge-code-lotus.svg';

let access_token = null;

class WebClient {
  async CreateConfig(multipart = false) {
    const str = Redux.store.getState();
    let config = {
      baseURL: '/base/',
      headers: {
        userIdentifier: str?.member?.id ?? null,
        languageId: str?.languageId ?? 1,
      },
    };

    if (str?.access_token) {
      config.headers['Authorization'] = `Bearer ${str.access_token}`;
    }

    if (multipart) {
      config.headers['Content-Type'] = 'multipart/form-data';
    }

    if (str?.member?.profileId) {
      config.headers['profileId'] = str?.member?.profileId;
      config.headers['patientId'] = str?.member?.patientId;
      config.headers['sessionId'] = str?.member?.sessionId;
    }

    console.log('str', str);

    if (str?.registerStart != null) {
      config.headers['X-User-Attr'] = str?.registerStart;
    }

    return config;
  }

  postWithParams = async (
    path,
    data,
    params,
    addProfile = false,
    toastSuccess = true,
    toastError = true
  ) => {
    let config = await this.CreateConfig();
    const str = Redux.store.getState();

    let d = { ...data };
    if (addProfile) {
      d = {
        profile: {
          guid: str.member?.guid ?? '',
          sessionId: str.member?.sessionId ?? '',
          patientId: str.member?.patientId ?? '',
          profileId: str.member?.profileId ?? '',
          userId: str.member?.userId ?? '',
        },
        data: data,
      };
    }

    const axios = Axios.create(config);
    let realPromise = axios.post(ToKebabCase(path), d, { params });
    return this.createProxyPromise(realPromise, toastSuccess, toastError);
  };

  post = async (path, data, addProfile = false, toastSuccess = true, toastError = true) => {
    let config = await this.CreateConfig();
    const str = Redux.store.getState();

    let d = { ...data };
    if (addProfile) {
      d = {
        profile: {
          guid: str.member?.guid ?? '',
          sessionId: str.member?.sessionId ?? '',
          patientId: str.member?.patientId ?? '',
          profileId: str.member?.profileId ?? '',
          userId: str.member?.userId ?? '',
        },
        data: data,
      };
    }

    const axios = Axios.create(config);
    let realPromise = axios.post(ToKebabCase(path), d);
    return this.createProxyPromise(realPromise, toastSuccess, toastError);
  };

  put = async (path, data, toastSuccess = true, toastError = true) => {
    let config = await this.CreateConfig();
    const axios = Axios.create(config);
    let realPromise = axios.put(ToKebabCase(path), data);
    return this.createProxyPromise(realPromise, toastSuccess, toastError);
  };

  get = async (path, toastSuccess = true, toastError = true) => {
    let config = await this.CreateConfig();
    const axios = Axios.create(config);
    let realPromise = axios.get(ToKebabCase(path));
    return this.createProxyPromise(realPromise, toastSuccess, toastError);
  };

  delete = async (path, data, toastSuccess = true, toastError = true) => {
    let config = await this.CreateConfig();
    const axios = Axios.create(config);
    let realPromise = axios.delete(ToKebabCase(path));
    return this.createProxyPromise(realPromise, toastSuccess, toastError);
  };

  welcome = async onError => {
    const str = Redux.store.getState();
    let cnfg = { baseURL: '/base/' };
    const axios = Axios.create(cnfg);

    const response = await axios
      .post('welcome.json', {
        languageId: str.languageId,
      })
      .catch(() => {
        if (onError) onError();
      });
    // if (response === undefined) Redux.toastError(Redux._fm("connection_error"))
    if (response?.status == 200) {
      Redux.setLanguages(response.data.data?.languages ?? []);
      if (response.data.data?.nationalities) {
        let a = response.data.data.nationalities.map(e => {
          return {
            ...e,
            value: e.id,
            label: e.name,
          };
        });
        Redux.setNationalities(a);
      }
      if (response.data.data?.genders) {
        let a = response.data.data.genders.map(e => {
          return {
            ...e,
            value: e.id,
            label: e.name,
          };
        });
        Redux.setGenders(a);
      }
      Redux.setMaintenance(response.data.data.isMaintenance);
      constants.baseURL = response.data.data.baseUrl;
      constants.imagePATH = response.data.data.baseImageUrl;
      constants.isDevelopment = response.data.data.isDevelopment;
      constants.siteUrl = response.data.data.baseSiteUrl;
      constants.reCaptchaSiteKey = response.data.data.recaptchaSiteKey;
      Redux.setVerifyForeignPatient(
        response.data.data.parameters
          .enableVerificationOfForeignPatientRecordsWithCallCenterApproval
      );
      constants.meetUrl = response.data.data.meetUrl;
    } else {
      if (onError) onError();
    }
  };

  createProxyPromise(realPromise, toastSuccess, toastError) {
    let _self = this;
    let proxyPromise = new Promise(function (resolve, reject) {
      realPromise
        .then(function (data) {
          _self.responseHandler(data, resolve, reject, toastSuccess, toastError);
        })
        .catch(error => {
          console.error(error);
          _self.errorHandler(error, reject);
        });
    });
    return proxyPromise;
  }

  responseHandler = async (response, callback, reject, toastSuccess, toastError) => {
    // if (toastSuccess && response?.data?.isSuccess) {

    // }
    if (toastError && !response?.data?.isSuccess) {
      // let msg = response?.data?.exception?.message ?? "Unauthorized";
      // Redux.toastError(Redux._fm(msg))
    }

    if (response.data.exception?.message == 'InvalidSessionProfile') {
      // Redux.toastErrorLocalized("your_session_has_expired_or_ended_please_try_logging_in_again")
      // Redux.logout()
    }

    callback(response.data);
  };

  errorHandler = async (error, reject) => {
    if (error.response !== undefined && error.response.status === 401) {
      toast.warning(error.response?.data?.exception?.message);
      Redux.logout();
    } else if (error.response !== undefined && error.response.status === 405) {
      // Redux.toastError(Redux._fm("invalid_request_method"))
      reject(error);
    } else if (error.response !== undefined && error.response.status === 403) {
      // toast.error(error.response.data.message)
      reject(error);
    } else if (error.response !== undefined && error.response.status === 404) {
      toast.warning('Endpoint not found!');
      reject(error);
    } else {
      // Redux.toastError(Redux._fm("connection_error"))
      reject(error);
    }
  };
}

export function setAccessToken(d) {
  access_token = d;
}

export function getAccessToken(d) {
  return access_token;
}

export const constants = {
  // spinner: require("../assets/pulse.svg"),
  baseURL: 'https://localhost:44302/',
  imagePATH: 'https://kochealthcare.blob.core.windows.net/',
  siteUrl: 'https://localhost:44305',
  applicationId: 3,
  applicationCode: 'APP03',
  isDevelopment: false,
  Exp727SurveyCode: '724EXP',
  meetUrl: '',
  orderStates: {
    completed: 0,
    approved: 1,
    pending: 2,
    canceled: 3,
    received: 4,
    refunded: 5,
  },
  paymentTypes: {
    package: 1,
    individualPayment: 2,
    provision: 3,
    paymentReceived: 4,
  },
  appointmentTypesCode: {
    physical: 'P',
    physicallyControl: 'K',
    online: 'F',
    onlineControl: 'B',
    tyto: 'M',
    tytocareControl: 'N',
    radiology: 'T',
  },
  serviceUsageTypes: {
    appointment: 1,
    emergenyCall: 2,
    checkUp: 3,
    ambulance: 4,
    transfer: 5,
  },
  loyaltyPageTypes: {
    none: 0,
    pointsTransfer: 1,
    pointsTransferRules: 2,
    inviteAndWin: 3,
    howDoIIncreaseMyPoints: 4,
    advantages: 5,
    whatIsKocHealthClub: 6,
    howDoIJoinKocHealthClub: 7,
    cta: 9,
  },
  contracts: {
    kvkk: { key: 'kvkk', value: 'KVKK' },
    etk: { key: 'etk', value: 'ETK' },
    clarification: { key: 'clarification', value: 'AYDINLATMA' },
    preliminaryInfo: { key: 'preliminaryInfo', value: 'ÖN BİLGİLENDİRME' },
    privacyPolicy: { key: 'privacyPolicy', value: 'GİZLİLİK POLİTİKASI' },
    distanceSales: { key: 'distanceSales', value: 'MESAFELİ SATIŞ SÖZLEŞMESİ' },
    consent: { key: 'consent', value: 'ONAM FORMU' },
    conditions: { key: 'conditions', value: 'KULLANIM KOŞULLARI' },
  },
  mealTypes: [
    { name: 'no_matter', type: 0 },
    { name: 'before_meals', type: 1 },
    { name: 'with_meals', type: 2 },
    { name: 'after_meals', type: 3 },
  ],
  theme: [
    {
      title: 'Koç Healthcare',
      name: 'theme-khc',
      logo: LogoKhc,
      badge: BadgeKhc,
    },
    /*         {
            title: "Code Lotus",
            name: "theme-codeLotus",
            logo: LogoCodeLotus,
            badge: BadgeCodeLotus
        } */
  ],
  reCaptchaSiteKey: '',
  allowedHost: 'portal.kochealthcare.org',
};

function ToKebabCase(full_path) {
  let all_parts = full_path.split('?');
  let path = all_parts[0];
  let query_string = all_parts.length > 1 ? '?' + all_parts[1] : '';
  let parts = path.startsWith('/') ? path.substr(1).split('/') : path.split('/');
  let new_parts = [];
  new_parts.push(parts[0]);
  for (let i = 1; i < parts.length; i++) {
    new_parts.push(parts[i].replace(/([a-z0–9])([A-Z])/g, '$1-$2').toLowerCase());
  }
  return new_parts.join('/') + (path.includes('.json') ? '' : '.json') + query_string;
}

export function GetQueryVariable(variable, search, def) {
  var query = search.substring(1);
  var vars = query.split('&');
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split('=');
    if (decodeURIComponent(pair[0]) == variable) {
      return decodeURIComponent(vars[i].replace(variable + '=', ''));
    }
  }
  return def;
}

export default WebClient;
